// extracted by mini-css-extract-plugin
module.exports = {"memo":"offer-aggre_memo__33DcL","memoLink":"offer-aggre_memoLink__VF_oW","dark":"offer-aggre_dark__XoJqK"};